<kpd-prevent-browser-close [prevent]="form.dirty"></kpd-prevent-browser-close>

<div class="detail__grid">
  <div class="detail__alert">
    <kpd-alert type="error" *ngIf="errorMessage" icon="error-standard">
      {{ errorMessage }}
    </kpd-alert>
    <kpd-alert type="warning" *ngIf="concurrencyErrorMessage" icon="warning-standard">
      {{ concurrencyErrorMessage }}
      <a style="color: #14a6fe;" (click)="reloadEntity(item)">{{ reloadMessage }}</a>
    </kpd-alert>
  </div>

  <div class="detail__toolbar ">
    <kpd-action-bar>
      <kpd-action
        icon="plus"
        (action)="onAdd()"
        [disable]="item.isNew()"
        [title]="'Add role' | translate"
        *kpdPermission="Permissions.RoleCreate"
      >
      </kpd-action>
      <kpd-action-edit-toggle
        [readMode]="!readOnlyMode"
        (action)="toggleReadOnly()"
        [disable]="form.dirty || item.isNew()"
        *kpdPermission="Permissions.RoleUpdate"
        [readMode]="false"
      ></kpd-action-edit-toggle>
      <ng-container *ngIf="!readOnlyMode">
        <kpd-action-save (action)="onSave(form)" [disable]="!form.dirty"></kpd-action-save>
        <kpd-action-undo (action)="onRevert()" [disable]="!form.dirty"></kpd-action-undo>
      </ng-container>
      <kpd-action-delete
        *kpdPermission="Permissions.RoleDelete"
        [disable]="item.isNew()"
        (action)="onDelete(item)"
      ></kpd-action-delete>
    </kpd-action-bar>
  </div>

  <form
    [formGroup]="form"
    kpdPreventEnterSubmit
    novalidate
    (kpdFocusChange)="onFocusChanged($event)"
    [ngClass]="{ update: !item.isNew(), 'form--edit-mode': !item.isNew(), create: item.isNew() }"
  >
    <kpd-collapse-panel title="{{ 'General' | translate }}" [collapsed]="false">
      <div class="flex-column form__column">
        <div class="form__control flex-row">
          <label>{{ 'Application' | translate }}:</label>
          <div class="form__input">
            <kpd-data-lookup
              [items]="applications"
              [readOnly]="readOnlyMode || !item.isNew()"
              formControlName="application"
              [name]="'application'"
              [title]="'Type' | translate"
              [displayField]="'name'"
              [searchField]="'name'"
              [valueField]="'name'"
              [columns]="applicationColumns"
            >
            </kpd-data-lookup>
          </div>
        </div>
        <div class="form__control flex-row">
          <label>{{ 'Name' | translate }}:</label>
          <div class="form__input">
            <kpd-text-input [readOnly]="readOnlyMode" formControlName="name" [name]="'name'"></kpd-text-input>
          </div>
        </div>
        <div class="form__control flex-row">
          <label>{{ 'Is assigned by default' | translate }}:</label>
          <div class="form__input">
            <kpd-toggle [readOnly]="readOnlyMode" formControlName="isAssignedByDefault"></kpd-toggle>
          </div>
        </div>
      </div>
      <div class="flex-column form__column">
        <div class="form__control flex-row">
          <label class=" ">{{ 'Description' | translate }}:</label>
          <div class="form__input">
            <kpd-text-area
              [readOnly]="readOnlyMode"
              formControlName="description"
              [name]="'description'"
              rows="5"
              [kpdSyncField]="languageFields"
            ></kpd-text-area>
          </div>
        </div>
      </div>
    </kpd-collapse-panel>

    <kpd-collapse-panel title="{{ 'Descriptions' | translate }}" [collapsed]="true" formGroupName="descriptions">
      <div class="flex-column form__column">
        <div class="form__control flex-row">
          <label class=" ">{{ 'Dutch' | translate }}:</label>
          <div class="form__input">
            <kpd-text-area
              [readOnly]="readOnlyMode"
              formControlName="dutch"
              [name]="'dutch'"
              rows="5"
              [kpdSyncField]="hasTranslationSync('dutch')"
            ></kpd-text-area>
          </div>
        </div>
        <div class="form__control flex-row">
          <label class=" ">{{ 'English' | translate }}:</label>
          <div class="form__input">
            <kpd-text-area
              [readOnly]="readOnlyMode"
              formControlName="english"
              [name]="'english'"
              rows="5"
              [kpdSyncField]="hasTranslationSync('english')"
            ></kpd-text-area>
          </div>
        </div>
        <div class="form__control flex-row">
          <label class=" ">{{ 'French' | translate }}:</label>
          <div class="form__input">
            <kpd-text-area
              [readOnly]="readOnlyMode"
              formControlName="french"
              [name]="'french'"
              rows="5"
              [kpdSyncField]="hasTranslationSync('french')"
            ></kpd-text-area>
          </div>
        </div>
        <div class="form__control flex-row">
          <label class=" ">{{ 'German' | translate }}:</label>
          <div class="form__input">
            <kpd-text-area
              [readOnly]="readOnlyMode"
              formControlName="german"
              [name]="'german'"
              rows="5"
              [kpdSyncField]="hasTranslationSync('german')"
            ></kpd-text-area>
          </div>
        </div>
      </div>
    </kpd-collapse-panel>
  </form>
</div>
